module.exports = __webpack_public_path__ + "static/media/440430914_337919472272129_2515768439564905124_n.d4a33275.jpg";